import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Show links (latest free half-episode lives on these).
const SPOTIFY_SHOW_URL = 'https://open.spotify.com/show/2jU246e6bhY0ML848jUHQz';
const APPLE_PODCASTS_URL =
    'https://podcasts.apple.com/sk/podcast/g%C3%B3ly-a-es%C3%A1-futbalov%C3%A9-anal%C3%BDzy-value-predikcie/id1879616734';

// --- Styled Components ---

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    width: 100%;
    max-width: 600px;
`;

const Logo = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-top: 20px;
`;

const CommunityName = styled.h1`
    font-size: 2em;
    margin-top: 14px;
    margin-bottom: 0;
    text-align: center;
`;

// Centered lead line under the title.
const Lead = styled.p`
    font-size: 0.95em;
    line-height: 1.5;
    color: #4b5159;
    margin: 12px auto 0;
    padding: 0 20px;
    max-width: 460px;
    text-align: center;
`;

// Left-aligned, structured intro sections (web only).
// Mobile keeps its DB-driven /headers/1 text — this component no longer fetches it.
const Sections = styled.div`
    width: 100%;
    max-width: 480px;
    margin: 22px auto 0;
    padding: 0 20px;
    text-align: left;
`;

const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const SectionTitle = styled.h3`
    font-size: 1.05em;
    font-weight: 800;
    color: #15171b;
    margin: 0;
`;

const SectionBody = styled.p`
    font-size: 0.9em;
    line-height: 1.5;
    color: #5b626c;
    margin: 0;
`;

const Divider = styled.div`
    height: 1px;
    background-color: #e7e9ed;
    margin: 16px 0;
`;

const SpotifyLink = styled.a`
    color: #1db954;
    font-weight: 600;
    text-decoration: none;
    &:hover { text-decoration: underline; }
`;

const AppleLink = styled.a`
    color: #9b2fe6;
    font-weight: 600;
    text-decoration: none;
    &:hover { text-decoration: underline; }
`;

const DbLink = styled(Link)`
    display: inline-block;
    margin-top: 6px;
    font-size: 0.95em;
    font-weight: 600;
    color: #007bff;
    text-decoration: none;
    &:hover { text-decoration: underline; color: #0056b3; }
`;

// --- Component ---

const ProfileHeader = () => {
    return (
        <Header>
            <Logo src="./g.png" alt="Community Logo" />

            <CommunityName>Góly a Esá – futbalová komunita</CommunityName>

            <Lead>
                Projekt postavený na VALUE prístupe, odbornosti a viac ako 17 rokov
                každodenného sledovania futbalu.
            </Lead>

            <Sections>
                <Section>
                    <SectionTitle>🎧 Každý týždeň nový podcast</SectionTitle>
                    <SectionBody>
                        Rozoberáme posledné hracie kolá, predikujeme tie nasledujúce a venujeme
                        sa najdôležitejším udalostiam z futbalového sveta.
                    </SectionBody>
                </Section>

                <Divider />

                <Section>
                    <SectionTitle>📲 Prémiový obsah obsahuje</SectionTitle>
                    <SectionBody>
                        všetky krátkodobé aj dlhodobé tikety, plné epizódy podcastov, kompletné
                        analýzy, predikcie a celý náš futbalový servis na jednom mieste.
                    </SectionBody>
                </Section>

                <Divider />

                <Section>
                    <SectionTitle>👋 Polovicu každej epizódy</SectionTitle>
                    <SectionBody>
                        si môžeš vypočuť zadarmo na{' '}
                        <SpotifyLink href={SPOTIFY_SHOW_URL} target="_blank" rel="noopener noreferrer">
                            Spotify
                        </SpotifyLink>{' '}
                        a{' '}
                        <AppleLink href={APPLE_PODCASTS_URL} target="_blank" rel="noopener noreferrer">
                            Apple Podcasts
                        </AppleLink>
                        .
                    </SectionBody>
                </Section>

                <Divider />

                <Section>
                    <SectionTitle>📊 Databáza našej práce</SectionTitle>
                    <DbLink to="/databaza-tipov">Prejsť na databázu tipov →</DbLink>
                </Section>
            </Sections>
        </Header>
    );
};

export default ProfileHeader;
